import CommitmentInfo from './CommitmentInfo';

export default CommitmentInfo;
